export default defineNuxtRouteMiddleware(async () => {
  const user = useUser()

  if (!user.value || ![304, 566].includes(user.value.id)) {
    throw createError({ statusCode: 401, statusMessage: 'Forbidden' })
  }
})
